/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Draft_PublishInputs */

const en_us2_coaching_draft_publish = /** @type {(inputs: Coaching_Draft_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve and publish`)
};

const pt_br2_coaching_draft_publish = /** @type {(inputs: Coaching_Draft_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovar e publicar`)
};

const pt_pt2_coaching_draft_publish = /** @type {(inputs: Coaching_Draft_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovar e publicar`)
};

/** @type {(inputs: Coaching_Draft_PublishInputs) => LocalizedString} */
const es_419_coaching_draft_publish = en_us2_coaching_draft_publish;

/** @type {(inputs: Coaching_Draft_PublishInputs) => LocalizedString} */
const fr_fr2_coaching_draft_publish = en_us2_coaching_draft_publish;

/** @type {(inputs: Coaching_Draft_PublishInputs) => LocalizedString} */
const de_de2_coaching_draft_publish = en_us2_coaching_draft_publish;

/** @type {(inputs: Coaching_Draft_PublishInputs) => LocalizedString} */
const it_it2_coaching_draft_publish = en_us2_coaching_draft_publish;

/**
* | output |
* | --- |
* | "Approve and publish" |
*
* @param {Coaching_Draft_PublishInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_draft_publish = /** @type {((inputs?: Coaching_Draft_PublishInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Draft_PublishInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_draft_publish(inputs)
	if (locale === "es-419") return es_419_coaching_draft_publish(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_draft_publish(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_draft_publish(inputs)
	if (locale === "de-DE") return de_de2_coaching_draft_publish(inputs)
	if (locale === "it-IT") return it_it2_coaching_draft_publish(inputs)
	return en_us2_coaching_draft_publish(inputs)
});
export { coaching_draft_publish as "coaching.draft_publish" }